import {removeUnderscore} from './removeMask';

const dayValidate = (day) => {
  const errorMessages = {
    messages: [
      {text: 'Dia inválido.', type: 'message-error-icon'},
      {text: 'Por favor, informe um dia válido!'}
    ]
  };

  if (day.length !== 2) throw errorMessages;

  day = Number.parseInt(day, 10);
  if (Number.isNaN(day) || day < 1 || day > 31) {
    throw errorMessages;
  }
};

const monthValidate = (month) => {
  const errorMessages = {
    messages: [
      {text: 'Mês inválido.', type: 'message-error-icon'},
      {text: 'Por favor, informe um mês válido!'}
    ]
  };

  if (month.length !== 2) throw errorMessages;

  month = Number.parseInt(month, 10);
  if (Number.isNaN(month) || month < 1 || month > 12) throw errorMessages;
};

const yearValidate = (year) => {
  const errorMessages = {
    messages: [
      {text: 'Ano inválido.', type: 'message-error-icon'},
      {text: 'Por favor, informe um ano válido!'}
    ]
  };

  if (year.length !== 4) throw errorMessages;

  year = Number.parseInt(year, 10);
  if (Number.isNaN(year)) throw errorMessages;

  const today = new Date();
  if (year > today.getFullYear()) throw errorMessages;
};

/**
 * 99-99-9999
 */
export const birthDateValidator = (birthDate) => {
  try {
    birthDate = removeUnderscore(birthDate);
    const date = birthDate.split('-');

    dayValidate(date[0]);
    monthValidate(date[1]);
    yearValidate(date[2]);

    return {status: true, partnerBd: birthDate};
  } catch (error) {
    return {status: false, partnerBd: '', error};
  }
};
